import React from "react";
import DarkTheme from "layouts/Dark";
import Navbar from "components/Navbar/navbar";
import Footer from "components/Footer/footer";
import CaseStudiesHeader from "components/CaseStudies-header/case-studies-header";
import CaseStudiesStyle from "components/CaseStudies-style/case-studies-style";
import { GetCaseStudiesData } from "components/ApiServices/GetCaseStudiesData";
import { useState } from "react";
import SEO from "components/seo/seo.jsx";
import LoadingScreen from "components/Loading-Screen";

const CaseStudiesPage = (props) => {
  const CaseStudiesData = GetCaseStudiesData();
  const fixedHeader = React.useRef(null);
  const MainContent = React.useRef(null);
  const navbarRef = React.useRef(null);
  const logoRef = React.useRef(null);
  const [theme, setTheme] = useState("Dark");

  React.useEffect(() => {
    setTimeout(() => {
      if (fixedHeader.current) {
        var slidHeight = fixedHeader.current.offsetHeight;
      }
      if (MainContent.current) {
        MainContent.current.style.marginTop = slidHeight + "px";
      }
    }, 1000);

    var navbar = navbarRef.current;

    if (window.pageYOffset > 300) {
      navbar.classList.add("nav-scroll");
    } else {
      navbar.classList.remove("nav-scroll");
    }

    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) {
        navbar.classList.add("nav-scroll");
      } else {
        navbar.classList.remove("nav-scroll");
      }
    });

    var storage = localStorage.getItem("theme");

    if (storage && storage != "") {
      let bodyEl = document.querySelector("body");
      bodyEl.classList.add("themeL");
      setTheme(storage);
    }
  }, [fixedHeader, MainContent, navbarRef]);

  const themeModeChange = (themeMode) => {
    let bodyEl = document.querySelector("body");
    if (themeMode == "Dark") {
      setTheme("themeL");
      bodyEl.classList.add("themeL");
      localStorage.setItem("theme", "themeL");
    } else {
      setTheme("Dark");
      bodyEl.classList.remove("themeL");
      localStorage.removeItem("theme");
    }
  };

  return (
    <DarkTheme>
      <LoadingScreen/>
      <div className="circle-bg">
        <div className="circle-color fixed">
          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </div>
      <Navbar
        nr={navbarRef}
        lr={logoRef}
        theme={theme}
        themeModeChange={themeModeChange}
      />
      <CaseStudiesHeader sliderRef={fixedHeader} />
      <div ref={MainContent} className="main-content">
        <CaseStudiesStyle
          grid={3}
          filterPosition="center"
          caseStudiesData={CaseStudiesData}
          propData={props}
          hideTitle
          hideFilter={true}
        />
        <Footer />
      </div>
    </DarkTheme>
  );
};

export const Head = ({ location }) => {
  return (
    <>
      <SEO
        pathname={location?.pathname || "/case-studies/"}
        title="Case Studies - Success Stories | Evolvan"
        description="Explore our case studies and see how Evolvan delivers exceptional digital solutions to businesses globally."
      />
    </>
  );
};

export default CaseStudiesPage;
